export default __webpack_public_path__ + "static/media/green-1.20a99001.svg";